<template>
    <div>
        <Header />
				<div class="breadcrumb-area gray-bg">
            <div class="container">
                <div class="breadcrumb-content">
                    <ul>
                        <li><router-link to="/">Home</router-link></li>
                        <li class="active"> Authentication</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="login-register-area pt-50 pb-50">
            <div class="container">
                <div class="row">
                    <div class="col-lg-7 col-md-12 ml-auto mr-auto">
											<div class="alert alert-success" role="alert" v-show="successAlert">
                            {{message}}
                        </div>
                        <div class="alert alert-danger" role="alert" v-show="errorAlert">
                            {{message}}
                        </div>
                        <div class="login-register-wrapper">
                            <div class="login-register-tab-list nav">
                                <a class="pb-2" :class="{active: login}" @click="toggleActive('login')">
                                    <h4> login </h4>
                                </a>
                                <a class="pb-2" :class="{active: register}" @click="toggleActive('register')">
                                    <h4> register </h4>
                                </a>
                            </div>
                            <div class="tab-content bg-white">
                                <div class="tab-pane" :class="{active: login}">
                                    <div class="login-form-container">
                                        <div class="login-register-form">
                                            <b-form-group id="input-group-1" label="Email address" label-for="input-1">
																									<b-form-input id="input-1" v-model="form.email" type="email" placeholder="Enter email" required></b-form-input>
																							</b-form-group>

																							<b-form-group id="input-group-2" label="Password" label-for="input-2">
																									<b-form-input id="input-2" v-model="form.password" type="password" placeholder="Enter password" required></b-form-input>
																							</b-form-group>
																							<b-row>
                                                <b-col lg="12" class="mt-4 button-container">
                                                    <b-button class="btn-fs" @click="emailLogin()">
                                                        <i class="fa fa-spinner fa-spin mt-2" style="float:left" v-show="loaderStatus"></i>
                                                        <i class="fa fa-envelope mt-2" style="float:left" v-show="!loaderStatus"></i>Login
                                                    </b-button>
                                                    <div class="login-toggle-btn">
                                                        <input type="checkbox" class="checkbox" v-model="rememberMe">
                                                        <label>Remember me</label>
                                                        <router-link to="/password/forgot">Forgot Password?</router-link>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane" :class="{active: register}">
                                    <div class="login-form-container">
                                        <div class="login-register-form">
                                           <b-form-group id="input-group-1" label="Username" label-for="input-1">
																							<b-form-input id="input-1" v-model="form.name" type="text" placeholder="Enter username" required></b-form-input>
																					</b-form-group>

																							<b-form-group id="input-group-2" label="Email address" label-for="input-2">
																								<b-form-input id="input-2" v-model="form.email" type="email" placeholder="Enter email" required></b-form-input>
																						</b-form-group>

																						<b-form-group id="input-group-3" label="Phone number" label-for="input-3">
																								<b-form-input id="input-3" v-model="form.phone_number" type="number" placeholder="Enter phone number" required></b-form-input>
																						</b-form-group>

																						<b-form-group id="input-group-4" label="Password" label-for="input-4">
																								<b-form-input id="input-4" v-model="form.password" type="password" placeholder="Enter password" required></b-form-input>
																						</b-form-group>

																							<b-form-group id="input-group-5" label="Password Confirmation" label-for="input-4">
																								<b-form-input id="input-4" v-model="form.password_confirmation" type="password" placeholder="Enter password confirnation" required></b-form-input>
																						</b-form-group>
																						<b-row>
                                                <b-col lg="12" class="mt-4 button-container">
                                                    <b-button class="btn-fs" @click="emailRegistration()">
                                                        <i class="fa fa-spinner fa-spin mt-2" style="float:left" v-show="loaderStatus"></i>
                                                        <i class="fa fa-envelope mt-2" style="float:left" v-show="!loaderStatus"></i>Create account
                                                    </b-button>                                                    
                                                </b-col>
                                            </b-row>

                                             <b-row v-show="false">
                                                <b-col lg="12" class="mt-4 button-container">
                                                     <g-signin-button :params="googleSignInParams" @success="onSignUpSuccess" @error="onSignUpError">
                                                        <i class="fa fa-google mt-2" style="float:left"></i>
                                                        Continue with Google
                                                    </g-signin-button>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>
<script>
    import { mapGetters, mapState, mapActions } from "vuex";  
    import Header from '../components/Header.vue'
    import Footer from '../components/Footer.vue'
    import GSignInButton from 'vue-google-signin-button'
    import User from "../apis/user";
    import Vue from 'vue'

    Vue.use(GSignInButton)

    export default {
        name: 'Login',
        components: {
            Header,
            Footer
        },
        data () {
            return {
                rememberMe: false,
                message: null,
                successAlert: false,
                errorAlert: false,
                loaderStatus: false,
                googleSignInParams: {
                    client_id: '372689969598-v7bl45dtk03j2obsugmvsgobe2ivked1.apps.googleusercontent.com'
                },
                form: {
                    name: null,
                    email: null,                    
                    phone_number: null,
                    password: null,
                    password_confirmation: null
                },
								login: true,
								register: false
            }
        },
        created: function () {
           localStorage.setItem("userData", null)
        },

        computed: {
            ...mapGetters(["errors"]),
             ...mapState("auth", ["userData"]),
        },

        mounted() {
            this.$store.commit("setErrors", {});
        },

        methods: {
            ...mapActions("auth", ["sendRegisterRequest", "sendLoginRequest", "registerEmail", "loginEmail"]),

            onSignUpSuccess (googleUser) {
                const profile = googleUser.getBasicProfile() 
                var idToken = googleUser.getAuthResponse().id_token;
                this.registerUser(profile, idToken)
            },
            
            onSignInSuccess (googleUser) {
                const profile = googleUser.getBasicProfile() 
                var idToken = googleUser.getAuthResponse().id_token;
                this.loginUser(profile, idToken)
            },

            onSignUpError (error) {
                //
            },

            onSignInError (error) {
                //
            },

            registerUser(profile, idToken) {
                var userProfile = {}

                userProfile.name = profile.sd
                userProfile.email = profile.kt
                userProfile.type = "social"
                userProfile.status = "active"
                userProfile.id_token = idToken

                this.sendRegisterRequest(userProfile).then(response => {
                    if(response) {
                        this.$router.push({ path: "/" });
                    }                    
                });
            },

            loginUser(profile, idToken) {
                var userProfile = {}
                userProfile.name = profile.sd
                userProfile.email = profile.nt
                userProfile.type = "social"
                userProfile.status = "active"
                userProfile.id_token = idToken

                this.sendLoginRequest(userProfile).then(response => {
                    if(response) {
                        this.$router.push({ path: "/" });
                    }                    
                });
            },

            signOut() {
                var auth2 = gapi.auth2.getAuthInstance();

                auth2.signOut().then(function () {
                });
            },

            emailRegistration() {
                this.form.type = "email"
                this.form.status = "active"
                this.loaderStatus = true
                this.errorAlert = false
                this.successAlert = false

                this.registerEmail(this.form).then(response => {
                    this.loaderStatus = false

                    if(response.status) {                            
                        this.login = true
												this.register = false
                        this.successAlert = true
                        this.message = response.message

                        this.form.name=null,
                        this.form.email=null,                    
                        this.form.phone_number=null,
                        this.form.password=null,
                        this.form.password_confirmation=null
                    }  
                    else 
                    {
                        this.errorAlert = true
                        this.message = response.message
                    }                       
                });
            },

            emailLogin() {
                var that = this

                this.loaderStatus = true
                this.errorAlert = false
                this.successAlert = false

                var user = {}
                user.email = this.form.email
                user.password = this.form.password
                user.remember_me = this.rememberMe

                var data = [];

                this.loginEmail(user)
                    .then(response => {
                        that.loaderStatus = false

                        if(response.status) {                            
                            that.$router.push({ path: "/" })
                        }  
                        else 
                        {
                            that.errorAlert = true
                            that.message = response.message
                        }               
                    })
            },
            
            onSubmit(event) {
                event.preventDefault()
                alert(JSON.stringify(this.form))
            },

            onReset(event) {
                event.preventDefault()
                // Reset our form values
                this.form.email = ''
                this.form.name = ''
                this.form.food = null
                this.form.checked = []
                // Trick to reset/clear native browser form validation state
                this.show = false
                this.$nextTick(() => {
                this.show = true
                })
            },

						toggleActive(tab) {
							if(tab == 'login') {
								this.login = true,
								this.register = false
							}
							else if (tab == 'register') {
								this.register = true,
								this.login = false
							}      
					},
        }
    }
</script>